var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "d2-container",
    [
      _c(
        "el-card",
        [
          _c("div", { attrs: { slot: "header" }, slot: "header" }, [
            _c("span", [_vm._v("代理区域管理")])
          ]),
          _c(
            "el-row",
            { attrs: { gutter: 20, align: "middle", type: "flex" } },
            [
              _c(
                "el-col",
                { attrs: { span: 16 } },
                [
                  _c(
                    "el-input",
                    {
                      attrs: {
                        placeholder: "搜索会员编号/省/市/区",
                        clearable: ""
                      },
                      on: { clear: _vm.onSearchChange },
                      nativeOn: {
                        keyup: function($event) {
                          if (
                            !$event.type.indexOf("key") &&
                            _vm._k(
                              $event.keyCode,
                              "enter",
                              13,
                              $event.key,
                              "Enter"
                            )
                          ) {
                            return null
                          }
                          return _vm.onSearchChange($event)
                        }
                      },
                      model: {
                        value: _vm.searchKeyword,
                        callback: function($$v) {
                          _vm.searchKeyword = $$v
                        },
                        expression: "searchKeyword"
                      }
                    },
                    [
                      _c("el-button", {
                        attrs: { slot: "append", icon: "el-icon-search" },
                        on: { click: _vm.onSearchChange },
                        slot: "append"
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "el-col",
                { staticStyle: { "text-align": "right" }, attrs: { span: 8 } },
                [
                  _c(
                    "el-button",
                    {
                      staticClass: "add-agent-btn",
                      attrs: { type: "primary", icon: "el-icon-plus" },
                      on: { click: _vm.showAddDialog }
                    },
                    [_vm._v("添加区域代理")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { icon: "el-icon-refresh" },
                      on: { click: _vm.loadData }
                    },
                    [_vm._v("刷新")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "el-card",
        { staticStyle: { "margin-top": "20px" } },
        [
          _c(
            "div",
            { attrs: { slot: "header" }, slot: "header" },
            [
              _c("span", [_vm._v("已设代理区域列表")]),
              _c(
                "el-tag",
                {
                  staticStyle: { "margin-left": "10px" },
                  attrs: { size: "small" }
                },
                [_vm._v("共 " + _vm._s(_vm.total) + " 个区域")]
              )
            ],
            1
          ),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading"
                }
              ],
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.pagedData,
                border: "",
                "header-cell-style": {
                  backgroundColor: "#F5F7FA",
                  color: "#2C3E50"
                }
              }
            },
            [
              _c("el-table-column", {
                attrs: {
                  type: "index",
                  label: "序号",
                  width: "60",
                  align: "center"
                }
              }),
              _c("el-table-column", {
                attrs: { prop: "number", label: "会员编号", width: "120" }
              }),
              _c("el-table-column", {
                attrs: { label: "姓名", width: "100" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              scope.row.t_user ? scope.row.t_user.real_name : ""
                            ) +
                            " "
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "电话", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(
                          " " +
                            _vm._s(
                              scope.row.t_user ? scope.row.t_user.phone : ""
                            ) +
                            " "
                        )
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "省", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(_vm._s(_vm.getAreaName(scope.row.province)))
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "市", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [_vm._v(_vm._s(_vm.getAreaName(scope.row.city)))]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { label: "区/县", width: "120" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _vm._v(_vm._s(_vm.getAreaName(scope.row.district)))
                      ]
                    }
                  }
                ])
              }),
              _c("el-table-column", {
                attrs: { prop: "add_time", label: "添加时间", width: "180" }
              }),
              _c("el-table-column", {
                attrs: {
                  label: "操作",
                  width: "150",
                  fixed: "right",
                  align: "center"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { size: "mini", type: "danger" },
                            on: {
                              click: function($event) {
                                return _vm.onRemove(scope.row)
                              }
                            }
                          },
                          [_vm._v("移除")]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _c("el-pagination", {
            staticStyle: { "margin-top": "20px", "text-align": "right" },
            attrs: {
              "current-page": _vm.currentPage,
              "page-sizes": [10, 20, 50, 100],
              "page-size": _vm.pageSize,
              total: _vm.total,
              layout: "total, sizes, prev, pager, next, jumper"
            },
            on: {
              "size-change": _vm.onSizeChange,
              "current-change": _vm.onPageChange
            }
          })
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "添加代理区域",
            visible: _vm.addDialogVisible,
            width: "600px",
            "append-to-body": true,
            "close-on-click-modal": false
          },
          on: {
            "update:visible": function($event) {
              _vm.addDialogVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticStyle: {
                "max-height": "50vh",
                "overflow-y": "auto",
                padding: "15px 30px"
              }
            },
            [
              _c(
                "el-form",
                {
                  ref: "addForm",
                  attrs: {
                    model: _vm.addForm,
                    rules: _vm.addRules,
                    "label-width": "100px"
                  }
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "会员编号", prop: "number" } },
                    [
                      _c("el-input", {
                        attrs: { placeholder: "请输入会员编号" },
                        model: {
                          value: _vm.addForm.number,
                          callback: function($$v) {
                            _vm.$set(_vm.addForm, "number", $$v)
                          },
                          expression: "addForm.number"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "选择区域", prop: "region" } },
                    [
                      _c("el-cascader", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          props: _vm.cascaderProps,
                          clearable: true,
                          filterable: true,
                          options: _vm.areaOptions,
                          placeholder: "请选择省/市/区"
                        },
                        model: {
                          value: _vm.addForm.region,
                          callback: function($$v) {
                            _vm.$set(_vm.addForm, "region", $$v)
                          },
                          expression: "addForm.region"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.addDialogVisible = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { type: "primary", loading: _vm.addLoading },
                  on: { click: _vm.onAddSubmit }
                },
                [_vm._v("添 加")]
              )
            ],
            1
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }